import React from 'react';
import { Link, Box, Theme } from '@mui/material';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { isArabicLocale } from '../../common/utils/checkLocalePlayer';
import { isNotSpaceOrEnterKey } from '../utils/accessibilityGenericMessage';
import { makeStyles } from 'tss-react/mui';

/** Props for NavButton Component */
type NavButtonProps = {
  next?: boolean;
};

const useStyles = makeStyles()((theme: Theme) => ({
  navButton: {
    color: theme.palette.secondary.contrastText,
    textDecoration: 'none',
    fontSize: '18px',
    display: 'inline-flex',
    alignItems: 'center',
    fontWeight: 600,
    cursor: 'pointer',

    '& svg': {
      color: theme.palette.secondary.contrastText,
    },
  },
}));

const NavButton = ({ next }: NavButtonProps): React.JSX.Element => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Box>
      {next ? (
        <Link
          className={classes.navButton}
          onKeyDown={(event: React.KeyboardEvent): void => {
            if (isNotSpaceOrEnterKey(event)) {
              return;
            }
            navigate(1);
          }}
          onClick={(): void => navigate(1)}
          tabIndex={0}>
          {t('next')} <ChevronRight fontSize="large" />
        </Link>
      ) : (
        <Link
          className={classes.navButton}
          onKeyDown={(event: React.KeyboardEvent): void => {
            if (isNotSpaceOrEnterKey(event)) {
              return;
            }
            navigate(-1);
          }}
          onClick={(): void => navigate(-1)}
          tabIndex={0}>
          {isArabicLocale() ? <ChevronRight fontSize="large" /> : <ChevronLeft fontSize="large" />} {t('back')}
        </Link>
      )}
    </Box>
  );
};

export default NavButton;
